export default {"src":"/_next/static/media/goodbye.7bce0a62.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};